import React from "react";
import "./EditButton.css";

const EditButton = ({onClick, label, icon, hoverIcon}) => {
  const [isHovered, setIsHovered] = React.useState(false);

  return (
    <button className="edit-button-frame" onClick={onClick} onMouseEnter={() => setIsHovered(true)} onMouseLeave={() => setIsHovered(false)}>
      <div className="edit-button-div">
        <img className="edit-button-vector" alt="Vector" src={isHovered && hoverIcon? hoverIcon : icon} />
        <div className="edit-button-text-wrapper">{label}</div>
      </div>
    </button>
  );
};


export default EditButton;